import { Link } from "react-router-dom";
import type { ScoopEvent } from "@/types/content";
import { formatHeat } from "@/utils/timeline";

interface EventCardProps {
  event: ScoopEvent;
  variant?: "grid" | "list";
  index?: number;
}

export default function EventCard({ event, variant = "grid", index = 0 }: EventCardProps) {
  if (variant === "list") {
    return (
      <Link
        to={`/events/${event.id}`}
        className="group flex items-start gap-4 py-4 border-b border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <span className="mt-0.5 font-heading text-lg font-black text-background-400 group-hover:text-primary-400 transition-colors w-8 shrink-0">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="flex-1 min-w-0">
          <span className="inline-flex items-center gap-2 text-[11px] text-primary-700">
            {event.category}
            <span className="text-foreground-400">{event.updateTime.slice(5, 16)}</span>
          </span>
          <span className="block mt-1.5 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
            {event.title}
          </span>
          <span className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-fire-line" />
              {formatHeat(event.heat)}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-time-line" />
              {event.timeline.length} 个节点
            </span>
          </span>
        </span>
      </Link>
    );
  }

  return (
    <article className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
      <Link to={`/events/${event.id}`} className="block w-full h-48 overflow-hidden cursor-pointer">
        <img
          src={event.cover}
          alt={`${event.title} - ${event.category}独家爆料事件时间线封面`}
          title={`${event.title} · 独家爆料`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-2.5 text-xs">
          <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-700 border border-primary-100">
            {event.category}
          </span>
          <span className="text-foreground-400">{event.updateTime}</span>
        </div>
        <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/events/${event.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
            {event.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{event.summary}</p>
        <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs">
          <span className="text-foreground-500">{event.timeline.length} 个时间线节点</span>
          <span className="inline-flex items-center gap-1 text-primary-700">
            <i className="ri-fire-line" />
            {formatHeat(event.heat)}
          </span>
        </div>
      </div>
    </article>
  );
}